// src/components/StreakDisplay.jsx
import React from "react";

export default function StreakDisplay({ streakData }) {
  if (!streakData) {
    return (
      <div className="card">
        <div className="text-xs text-slate-500 uppercase tracking-wider mb-3">Streaks</div>
        <div className="text-center py-4 text-slate-600 text-sm">Log daily to start streaks</div>
      </div>
    );
  }

  const streaks = [
    {
      label: "Logging",
      current: streakData.current_logging_streak,
      best:    streakData.best_logging_streak,
      icon:    "📅",
    },
    {
      label: "Protein",
      current: streakData.current_protein_streak,
      best:    streakData.best_protein_streak,
      icon:    "🥩",
    },
    {
      label: "Calories",
      current: streakData.current_calorie_streak,
      best:    streakData.best_calorie_streak,
      icon:    "🎯",
    },
  ];

  return (
    <div className="card">
      <div className="text-xs text-slate-500 uppercase tracking-wider mb-3">🔥 Streaks</div>
      <div className="space-y-3">
        {streaks.map(({ label, current, best, icon }) => (
          <div key={label} className="flex items-center justify-between">
            <div className="flex items-center gap-2">
              <span className="text-base">{icon}</span>
              <span className="text-xs text-slate-400">{label}</span>
            </div>
            <div className="flex items-center gap-3">
              <div className="text-right">
                <div className={`text-lg font-bold leading-none ${current > 0 ? "text-[#ff7c0a]" : "text-slate-600"}`}
                     style={{ fontFamily: "'Barlow Condensed', sans-serif" }}>
                  {current}
                </div>
                <div className="text-[10px] text-slate-600">current</div>
              </div>
              <div className="text-right">
                <div className="text-lg font-bold leading-none text-slate-500"
                     style={{ fontFamily: "'Barlow Condensed', sans-serif" }}>
                  {best}
                </div>
                <div className="text-[10px] text-slate-600">best</div>
              </div>
            </div>
          </div>
        ))}
      </div>
    </div>
  );
}
